module.exports = __webpack_public_path__ + "img/gameinfo_2_.32715b3a.png";